// Utilitário compartilhado para navegação da pipeline de embarques
// Dependência única: constants/LOG_ST_EMBARQUE.js (auto-gerado)
import { LOG_ST_EMBARQUE } from '@/constants/LOG_ST_EMBARQUE'

// ============================================================
// MAPA: Status do backend → Sequência numérica
// Baseado em LOG_ST_EMBARQUE.cs (campo SequenciaLista)
// ============================================================
export const STATUS_SEQ = {
  [LOG_ST_EMBARQUE.DigitandoMateriais]: 1,
  [LOG_ST_EMBARQUE.ValidandoLpcoPre]: 2,
  [LOG_ST_EMBARQUE.Preembarque]: 3,
  [LOG_ST_EMBARQUE.Transito]: 4,
  [LOG_ST_EMBARQUE.ValidandoLpcoPos]: 5,
  [LOG_ST_EMBARQUE.Desembaracado]: 6,
  [LOG_ST_EMBARQUE.Finalizado]: 7,
  [LOG_ST_EMBARQUE.Cancelado]: 8
}

// ============================================================
// MAPA: Status do backend → Pipeline stage (frontend)
// Vários status podem mapear para a mesma stage (ex: todos
// os status pós-validação mapeiam para 'embarque')
// ============================================================
export const STATUS_TO_STAGE = {
  [LOG_ST_EMBARQUE.DigitandoMateriais]: 'materiais',
  [LOG_ST_EMBARQUE.ValidandoLpcoPre]: 'validacao',
  [LOG_ST_EMBARQUE.Preembarque]: 'embarque',
  [LOG_ST_EMBARQUE.Transito]: 'embarque',
  [LOG_ST_EMBARQUE.ValidandoLpcoPos]: 'embarque',
  [LOG_ST_EMBARQUE.Desembaracado]: 'embarque',
  [LOG_ST_EMBARQUE.Finalizado]: 'embarque',
  [LOG_ST_EMBARQUE.Cancelado]: 'embarque'
}

// ============================================================
// PIPELINE STAGES (definição centralizada)
// Usado por EmbarquesCadastro e ComexPipelineStatus
// ============================================================
export const PIPELINE_STAGES = [
  { key: 'materiais', label: 'Digitação de Materiais', icon: 'bi-inboxes', color: 'var(--bs-warning)' },
  { key: 'validacao', label: 'Validação LPCO Pré', icon: 'bi-shield-check', color: 'var(--bs-warning)' },
  { key: 'embarque', label: 'Embarque', icon: 'bi-ship', color: 'var(--bs-info)' },
  { key: 'estocagem', label: 'Estocagem', icon: 'bi-box-seam', color: 'var(--bs-success)' },
  { key: 'aduana', label: 'Doc. Aduaneira', icon: 'bi-shield-check', color: 'var(--bs-danger)' }
]

// ============================================================
// HELPERS
// ============================================================

/**
 * Retorna o índice de uma stage na pipeline
 */
export const getStageIndex = (stageKey) => PIPELINE_STAGES.findIndex(s => s.key === stageKey)

/**
 * Retorna a pipeline stage atual baseada no status do backend
 * @param {string} lstStatusEmbarque - Código do status (ex: 'LOG_ST_EMBARQUE7')
 * @returns {string} key da stage (ex: 'validacao')
 */
export const getCurrentStage = (lstStatusEmbarque) => STATUS_TO_STAGE[lstStatusEmbarque] || 'materiais'

/**
 * Verifica se a navegação para uma stage alvo é uma retroação (voltar)
 * @param {string} lstStatusEmbarque - Status atual do backend
 * @param {string} stageKey - Stage alvo no frontend
 * @returns {boolean}
 */
export const isNavegacaoParaTras = (lstStatusEmbarque, stageKey) => {
  if (!lstStatusEmbarque) return false
  const currentStage = getCurrentStage(lstStatusEmbarque)
  const currentIdx = getStageIndex(currentStage)
  const targetIdx = getStageIndex(stageKey)
  return targetIdx < currentIdx
}

/**
 * Verifica se uma etapa da pipeline está habilitada para clique
 * Regras:
 *  - Etapas anteriores ou iguais à ativa: sempre habilitadas
 *  - Próxima etapa: habilitada (avanço de 1)
 *  - Demais: desabilitadas
 * @param {string} lstStatusEmbarque - Status atual do backend
 * @param {string} stageKey - Stage sendo verificada
 * @param {number} stageIndex - Índice da stage na pipeline
 * @param {number} activeIndex - Índice da stage ativa
 * @returns {boolean}
 */
export const isEtapaHabilitada = (lstStatusEmbarque, stageKey, stageIndex, activeIndex) => {
  // Etapas anteriores ou iguais à ativa: sempre habilitadas (permite voltar)
  if (stageIndex <= activeIndex) return true

  // Só pode avançar 1 etapa por vez
  if (stageIndex === activeIndex + 1) return true

  return false
}

/**
 * Obtém a sequência numérica do status do backend
 * @param {string} lstStatusEmbarque
 * @returns {number|null}
 */
export const getStatusSeq = (lstStatusEmbarque) => {
  if (!lstStatusEmbarque) return null
  return STATUS_SEQ[lstStatusEmbarque] || null
}
